import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Modal, Popconfirm, Space, notification } from "antd";
import { useState } from "react";
import { AdminService } from "../../services/AdminService";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import CreateAdmin from "./CreateAdmin";

export default function Admin() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Fullname',
            align: 'center',
            dataIndex: 'full_name',
            key: 'full_name',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Email',
            align: 'center',
            dataIndex: 'email',
            key: 'email',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Created Date',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value, record) => {
                return value && moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div>

                        <Popconfirm
                            placement="left"
                            title="Delete the account"
                            description="You cannot rollback this admin."
                            okText="Yes"
                            cancelText="No"
                            onConfirm={(e) => {
                                onDelete(record.id)
                            }}
                        >
                            <Button type="primary" danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </Popconfirm>
                    </Flex>
                )
            }
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await AdminService.getAdmins(payload)
        return res
    }

    const onDelete = async (id: number) => {
        const res = await AdminService.deleteAdmin(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }



    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateAdmin
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateAdmin>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Admin',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Manage Admin"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
